module.exports = __webpack_public_path__ + "img/20171229_164739.c3694629.jpg";